<template>
<td>
    <div :class="classObject">      
    </div>
</td>
</template>
<script>
export default { 
    name: "CellContainer",   
    props: {
        dataItem: Object
    },
    computed: {
        classObject: function () {          
          return this.dataItem["auswerteStatus"]
        }
    }
}
</script>

<style lang="scss" scoped>
  .status__offline--always {
    background-image: linear-gradient(120deg, rgb(195, 199, 201), rgb(8, 9, 12));
    height: 22px;
    width: 22px;
  }
  .status__offline--heartbeatmissing {
    background-image: linear-gradient(120deg, rgb(233, 233, 233), rgb(194, 194, 194));
    height: 22px;
    width: 22px;
  }
.status__online--ok {
    background-image: linear-gradient(120deg, rgb(103, 211, 3), rgb(23, 129, 1));
    height: 22px;
    width: 22px;
  }

  .status__online--hartbeattimeout {
    background-image: linear-gradient(120deg, rgba(252, 111, 111, 0.596), rgba(250, 4, 4, 0.596));
    height: 22px;
    width: 22px;
  }

  .status__offline-unknown {
     background-image: linear-gradient(120deg, rgba(126, 165, 250, 0.596), rgba(85, 138, 252, 0.596));
    height: 22px;
    width: 22px;
  }

  .status__offline--mode {
    background-image: linear-gradient(120deg, rgba(111, 113, 252, 0.486), rgba(2, 6, 252, 0.486));
    height: 22px;
    width: 22px;
  }

  .status__online--emergency {
     background-image: linear-gradient(120deg, rgba(250, 193, 86, 0.596), rgba(255, 166, 0, 0.63));
    height: 22px;
    width: 22px;
  }

  .status__online--emergency--quit {
    background-image: linear-gradient(120deg, rgb(211, 247, 179), rgb(196, 246, 186));
    height: 22px;
    width: 22px;
  }
</style>
